import React, { useEffect, useRef, useState } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { getStations } from '../services/api';

// All TotalEnergies stations in Senegal (GPS from OpenStreetMap Overpass API)
const ALL_STATIONS = [
  // DAKAR
  { nom: 'Total Ouakam', lat: 14.7193978, lng: -17.4869502, ville: 'Dakar', region: 'Dakar' },
  { nom: 'Total Ouakam 2', lat: 14.7183951, lng: -17.4876976, ville: 'Dakar', region: 'Dakar' },
  { nom: 'Total Almadies', lat: 14.7497039, lng: -17.5045723, ville: 'Dakar', region: 'Dakar' },
  { nom: 'Total Almadies 2', lat: 14.7520292, lng: -17.5010804, ville: 'Dakar', region: 'Dakar' },
  { nom: 'Total Gueule Tapee', lat: 14.6790160, lng: -17.4591784, ville: 'Dakar', region: 'Dakar' },
  { nom: 'Total Medina', lat: 14.6768205, lng: -17.4456917, ville: 'Dakar', region: 'Dakar' },
  { nom: 'TotalEnergies VDN', lat: 14.6981603, lng: -17.4442739, ville: 'Dakar', region: 'Dakar' },
  { nom: 'Total Plateau', lat: 14.6733559, lng: -17.4313552, ville: 'Dakar', region: 'Dakar' },
  { nom: 'Total Dior', lat: 14.7586271, lng: -17.4476056, ville: 'Dakar', region: 'Dakar' },
  { nom: 'Total Case Bi', lat: 14.7560905, lng: -17.4292479, ville: 'Dakar', region: 'Dakar' },
  { nom: 'Total Camberene', lat: 14.7566915, lng: -17.4282005, ville: 'Dakar', region: 'Dakar' },
  { nom: 'Total Grand Dakar', lat: 14.6973614, lng: -17.4572519, ville: 'Dakar', region: 'Dakar' },
  { nom: 'Total Colobane', lat: 14.6999130, lng: -17.4474303, ville: 'Dakar', region: 'Dakar' },
  { nom: 'Total Fass', lat: 14.7020092, lng: -17.4561138, ville: 'Dakar', region: 'Dakar' },
  { nom: 'Total HLM', lat: 14.6979366, lng: -17.4673220, ville: 'Dakar', region: 'Dakar' },
  { nom: 'Total OMVS Fann', lat: 14.6983732, lng: -17.4674238, ville: 'Dakar', region: 'Dakar' },
  { nom: 'Total Fann', lat: 14.7283046, lng: -17.4567803, ville: 'Dakar', region: 'Dakar' },
  { nom: 'Total Parcelles Assainies', lat: 14.7474854, lng: -17.4446387, ville: 'Dakar', region: 'Dakar' },
  { nom: 'Total Grand Yoff', lat: 14.7451012, lng: -17.4191542, ville: 'Dakar', region: 'Dakar' },
  { nom: 'Total Technopole', lat: 14.7463616, lng: -17.4114534, ville: 'Dakar', region: 'Dakar' },
  { nom: 'Total Hann', lat: 14.7410615, lng: -17.4702871, ville: 'Dakar', region: 'Dakar' },
  { nom: 'Total Sud Dakar', lat: 14.6635908, lng: -17.4374964, ville: 'Dakar', region: 'Dakar' },
  // PIKINE / GUEDIAWAYE
  { nom: 'Total Pikine Prefecture', lat: 14.7711245, lng: -17.3862392, ville: 'Pikine', region: 'Dakar' },
  { nom: 'Total Pikine Tally Bou Mack', lat: 14.7645112, lng: -17.3909475, ville: 'Pikine', region: 'Dakar' },
  { nom: 'Total Pikine Tally Icotaf', lat: 14.7614021, lng: -17.3857469, ville: 'Pikine', region: 'Dakar' },
  { nom: 'Total Pikine Route Nationale', lat: 14.7686553, lng: -17.3957746, ville: 'Pikine', region: 'Dakar' },
  { nom: 'Total Icotaf', lat: 14.7436826, lng: -17.3989936, ville: 'Pikine', region: 'Dakar' },
  { nom: 'Total Yeumbeul', lat: 14.7754222, lng: -17.3594878, ville: 'Yeumbeul', region: 'Dakar' },
  { nom: 'Total Sicap Mbao', lat: 14.7476420, lng: -17.3536731, ville: 'Mbao', region: 'Dakar' },
  { nom: 'Total Keur Massar', lat: 14.7481018, lng: -17.3470033, ville: 'Keur Massar', region: 'Dakar' },
  { nom: 'Total Khar Yalla', lat: 14.7282044, lng: -17.4525790, ville: 'Dakar', region: 'Dakar' },
  // RUFISQUE / DIAMNIADIO
  { nom: 'TotalEnergies Rufisque', lat: 14.7071320, lng: -17.2571769, ville: 'Rufisque', region: 'Dakar' },
  { nom: 'Total Minam 1', lat: 14.7702349, lng: -17.3192157, ville: 'Rufisque', region: 'Dakar' },
  { nom: 'Total Minam 2', lat: 14.7689679, lng: -17.3190253, ville: 'Rufisque', region: 'Dakar' },
  { nom: 'Total Diass AIBD', lat: 14.7179615, lng: -17.1894171, ville: 'Diass', region: 'Thies' },
  { nom: 'Total Diamniadio', lat: 14.7201444, lng: -17.1826997, ville: 'Diamniadio', region: 'Dakar' },
  // THIES
  { nom: 'Total Place de France', lat: 14.7923648, lng: -16.9251388, ville: 'Thies', region: 'Thies' },
  { nom: 'Total Route Saint-Louis', lat: 14.8004710, lng: -16.9266903, ville: 'Thies', region: 'Thies' },
  { nom: 'Total Clemenceau', lat: 14.7963213, lng: -16.9255564, ville: 'Thies', region: 'Thies' },
  { nom: 'Total Rue de Paris', lat: 14.7990580, lng: -16.9268985, ville: 'Thies', region: 'Thies' },
  { nom: 'Total Thies Sud', lat: 14.7864001, lng: -16.9179959, ville: 'Thies', region: 'Thies' },
  { nom: 'Total Thies Centre', lat: 14.7889407, lng: -16.9300790, ville: 'Thies', region: 'Thies' },
  { nom: 'Total Thies RN', lat: 14.7795663, lng: -16.9161539, ville: 'Thies', region: 'Thies' },
  { nom: 'Total Pout', lat: 14.7624279, lng: -17.0629166, ville: 'Pout', region: 'Thies' },
  { nom: 'TotalEnergies Pout 2', lat: 14.7381665, lng: -17.1442146, ville: 'Pout', region: 'Thies' },
  { nom: 'Total Route Tivaouane', lat: 14.7642501, lng: -16.6882405, ville: 'Tivaouane', region: 'Thies' },
  { nom: 'Total Tivaouane', lat: 14.7669591, lng: -16.7352945, ville: 'Tivaouane', region: 'Thies' },
  // MBOUR
  { nom: 'Total Mbour 1', lat: 14.4484274, lng: -16.9812706, ville: 'Mbour', region: 'Thies' },
  { nom: 'Total Mbour 2', lat: 14.4655345, lng: -16.9873983, ville: 'Mbour', region: 'Thies' },
  // DIOURBEL
  { nom: 'TotalEnergies Diourbel', lat: 14.9560018, lng: -16.8164674, ville: 'Diourbel', region: 'Diourbel' },
  { nom: 'TotalEnergies Bambey', lat: 14.8175486, lng: -15.8985845, ville: 'Bambey', region: 'Diourbel' },
  // LOUGA / MECKHE
  { nom: 'Total Meckhe', lat: 15.1124836, lng: -16.6385635, ville: 'Meckhe', region: 'Louga' },
  { nom: 'Total Louga 1', lat: 15.3457749, lng: -15.4908516, ville: 'Louga', region: 'Louga' },
  { nom: 'Total Louga 2', lat: 15.3493544, lng: -15.4787241, ville: 'Louga', region: 'Louga' },
  { nom: 'Total Route Linguere', lat: 15.3956053, lng: -15.1164220, ville: 'Linguere', region: 'Louga' },
  { nom: 'Total Kebemer', lat: 15.3741334, lng: -16.4494655, ville: 'Kebemer', region: 'Louga' },
  // SAINT-LOUIS
  { nom: 'Total Saint-Louis 1', lat: 16.0226346, lng: -16.4918924, ville: 'Saint-Louis', region: 'Saint-Louis' },
  { nom: 'Total Saint-Louis 2', lat: 16.0231855, lng: -16.5074432, ville: 'Saint-Louis', region: 'Saint-Louis' },
  { nom: 'Total Saint-Louis 3', lat: 16.0206010, lng: -16.4989011, ville: 'Saint-Louis', region: 'Saint-Louis' },
  { nom: 'Total Saint-Louis 4', lat: 16.0246595, lng: -16.4955132, ville: 'Saint-Louis', region: 'Saint-Louis' },
  { nom: 'TotalEnergies Richard-Toll', lat: 16.5025453, lng: -15.8097993, ville: 'Richard-Toll', region: 'Saint-Louis' },
  // KAOLACK / FATICK
  { nom: 'Total Kaolack 1', lat: 14.1349496, lng: -16.0734117, ville: 'Kaolack', region: 'Kaolack' },
  { nom: 'Total Kaolack 2', lat: 14.1346414, lng: -16.0712458, ville: 'Kaolack', region: 'Kaolack' },
  { nom: 'Total Kaolack 3', lat: 14.1313352, lng: -16.0705595, ville: 'Kaolack', region: 'Kaolack' },
  { nom: 'Total Route Foundiougne', lat: 14.1866775, lng: -16.8591434, ville: 'Fatick', region: 'Fatick' },
  // KAFFRINE
  { nom: 'Total Kaffrine 1', lat: 14.6930700, lng: -16.4523952, ville: 'Kaffrine', region: 'Kaffrine' },
  { nom: 'Total Kaffrine 2', lat: 14.6935552, lng: -16.4569804, ville: 'Kaffrine', region: 'Kaffrine' },
  // TAMBACOUNDA
  { nom: 'Total Tambacounda 1', lat: 13.7566847, lng: -15.7795222, ville: 'Tambacounda', region: 'Tambacounda' },
  { nom: 'TotalEnergies Tambacounda 2', lat: 13.7460529, lng: -15.7748285, ville: 'Tambacounda', region: 'Tambacounda' },
  { nom: 'Total Tambacounda RN', lat: 13.9813540, lng: -14.8070855, ville: 'Tambacounda', region: 'Tambacounda' },
  // KEDOUGOU
  { nom: 'Total Kedougou', lat: 12.5571905, lng: -12.1792963, ville: 'Kedougou', region: 'Kedougou' },
  // MATAM
  { nom: 'Total Matam 1', lat: 15.6257737, lng: -16.2432572, ville: 'Matam', region: 'Matam' },
  { nom: 'Total Matam 2', lat: 15.6087859, lng: -13.3194633, ville: 'Matam', region: 'Matam' },
  { nom: 'Total Bakel', lat: 14.9004879, lng: -12.4546779, ville: 'Bakel', region: 'Tambacounda' },
  { nom: 'Total Ranerou', lat: 15.2956179, lng: -13.9577010, ville: 'Ranerou', region: 'Matam' },
  // ZIGUINCHOR / CASAMANCE
  { nom: 'Total Ziguinchor 1', lat: 12.5835108, lng: -16.2711434, ville: 'Ziguinchor', region: 'Ziguinchor' },
  { nom: 'Total Ziguinchor 2', lat: 12.5823597, lng: -16.2674284, ville: 'Ziguinchor', region: 'Ziguinchor' },
  { nom: 'Total Ziguinchor 3', lat: 12.5777316, lng: -16.2749414, ville: 'Ziguinchor', region: 'Ziguinchor' },
  { nom: 'Total Ziguinchor 4', lat: 12.5828520, lng: -16.2633752, ville: 'Ziguinchor', region: 'Ziguinchor' },
  { nom: 'Total Cap Skirring', lat: 12.3781964, lng: -16.7302825, ville: 'Cap Skirring', region: 'Ziguinchor' },
  { nom: 'Total Bignona 1', lat: 12.7984548, lng: -16.2253241, ville: 'Bignona', region: 'Ziguinchor' },
  { nom: 'Total Bignona 2', lat: 12.7971753, lng: -16.2283599, ville: 'Bignona', region: 'Ziguinchor' },
  { nom: 'Total Goudomp', lat: 12.5711893, lng: -15.8853730, ville: 'Goudomp', region: 'Sedhiou' },
  // KOLDA / SEDHIOU
  { nom: 'Total Kolda 1', lat: 12.8914913, lng: -14.9397625, ville: 'Kolda', region: 'Kolda' },
  { nom: 'Total Kolda 2', lat: 12.8918594, lng: -14.9390846, ville: 'Kolda', region: 'Kolda' },
  { nom: 'Total Sedhiou', lat: 12.9128413, lng: -14.1528738, ville: 'Sedhiou', region: 'Sedhiou' },
  { nom: 'TotalEnergies Velingara', lat: 13.1458672, lng: -14.1005559, ville: 'Velingara', region: 'Kolda' },
  { nom: 'Total Diouloulou', lat: 13.6116522, lng: -16.4277224, ville: 'Diouloulou', region: 'Ziguinchor' },
];

const REGIONS = Array.from(new Set(ALL_STATIONS.map(s => s.region))).sort();

const Cartographie: React.FC = () => {
  const mapRef = useRef<HTMLDivElement>(null);
  const mapInstance = useRef<L.Map | null>(null);
  const [managed, setManaged] = useState<any[]>([]);
  const [regionFilter, setRegionFilter] = useState('');
  const [showAll, setShowAll] = useState(true);
  const [showManaged, setShowManaged] = useState(true);
  const markersRef = useRef<L.LayerGroup | null>(null);
  const managedMarkersRef = useRef<L.LayerGroup | null>(null);

  useEffect(() => {
    getStations().then(r => setManaged(r.data)).catch(console.error);
  }, []);

  useEffect(() => {
    if (!mapRef.current || mapInstance.current) return;

    const map = L.map(mapRef.current).setView([14.5, -15.5], 7);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap contributors'
    }).addTo(map);

    mapInstance.current = map;
    markersRef.current = L.layerGroup().addTo(map);
    managedMarkersRef.current = L.layerGroup().addTo(map);

    return () => { map.remove(); mapInstance.current = null; };
  }, []);

  useEffect(() => {
    if (!mapInstance.current || !markersRef.current || !managedMarkersRef.current) return;

    // Clear existing
    markersRef.current.clearLayers();
    managedMarkersRef.current.clearLayers();

    // All stations (grey markers)
    if (showAll) {
      const filtered = regionFilter
        ? ALL_STATIONS.filter(s => s.region === regionFilter)
        : ALL_STATIONS;

      filtered.forEach(s => {
        const icon = L.divIcon({
          className: 'custom-marker',
          html: `<div style="
            width:12px;height:12px;border-radius:50%;
            background:#FF6B35;border:2px solid #fff;
            box-shadow:0 1px 4px rgba(0,0,0,0.3);
          "></div>`,
          iconSize: [12, 12],
          iconAnchor: [6, 6],
        });

        L.marker([s.lat, s.lng], { icon })
          .bindPopup(`
            <div style="font-family:sans-serif;min-width:160px">
              <strong style="color:#004A97">${s.nom}</strong><br/>
              <span style="font-size:12px;color:#666">${s.ville}, ${s.region}</span><br/>
              <span style="font-size:11px;color:#999">${s.lat.toFixed(5)}, ${s.lng.toFixed(5)}</span>
            </div>
          `)
          .addTo(markersRef.current!);
      });
    }

    // Managed stations (red markers, larger)
    if (showManaged && managed.length > 0) {
      const filtered = regionFilter
        ? managed.filter((s: any) => s.region === regionFilter)
        : managed;

      filtered.forEach((s: any) => {
        if (!s.latitude || !s.longitude) return;

        const icon = L.divIcon({
          className: 'custom-marker-managed',
          html: `<div style="
            width:22px;height:22px;border-radius:50%;
            background:#ED0000;border:3px solid #fff;
            box-shadow:0 2px 8px rgba(0,0,0,0.4);
            display:flex;align-items:center;justify-content:center;
            color:#fff;font-size:10px;font-weight:bold;
          "><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' width='10' height='10' fill='white'><path d='M32 64C32 28.7 60.7 0 96 0H256c35.3 0 64 28.7 64 64V256h8c48.6 0 88 39.4 88 88v32c0 13.3 10.7 24 24 24s24-10.7 24-24V222c-27.6-7.1-48-32.2-48-62V128L360 73c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l74.3 74.3c6 6 9.4 14.1 9.4 22.6V160c0 17.7-14.3 32-32 32V376c0 39.8-32.2 72-72 72s-72-32.2-72-72V344c0-22.1-17.9-40-40-40h-8V448c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V64zM96 80v96c0 8.8 7.2 16 16 16H240c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16z'/></svg></div>`,
          iconSize: [22, 22],
          iconAnchor: [11, 11],
        });

        L.marker([Number(s.latitude), Number(s.longitude)], { icon })
          .bindPopup(`
            <div style="font-family:sans-serif;min-width:200px">
              <div style="background:#ED0000;color:#fff;padding:6px 10px;margin:-10px -10px 8px;border-radius:4px 4px 0 0">
                <strong>${s.nom}</strong>
              </div>
              <div style="font-size:12px;line-height:1.6">
                <div><strong>Code:</strong> ${s.code}</div>
                <div><strong>Adresse:</strong> ${s.adresse}</div>
                <div><strong>Ville:</strong> ${s.ville}</div>
                <div><strong>Region:</strong> ${s.region}</div>
                <div><strong>Type:</strong> ${s.type_station}</div>
                <div><strong>Gerant:</strong> ${s.gerant_prenom || ''} ${s.gerant_nom || ''}</div>
                <div><strong>Capacite:</strong> ${Number(s.capacite_totale).toLocaleString()} L</div>
                <div><strong>Statut:</strong> <span style="color:${s.statut === 'active' ? '#78BE20' : '#ED0000'}">${s.statut}</span></div>
              </div>
            </div>
          `)
          .addTo(managedMarkersRef.current!);
      });
    }
  }, [showAll, showManaged, managed, regionFilter]);

  const stationsFiltered = regionFilter
    ? ALL_STATIONS.filter(s => s.region === regionFilter)
    : ALL_STATIONS;
  const managedFiltered = regionFilter
    ? managed.filter((s: any) => s.region === regionFilter)
    : managed;

  return (
    <div>
      <div className="page-header">
        <h2>Cartographie des Stations TotalEnergies</h2>
        <span className="badge">{ALL_STATIONS.length} stations repertoriees</span>
      </div>

      <div className="carto-controls">
        <div className="filters" style={{ marginBottom: 12 }}>
          <select value={regionFilter} onChange={e => setRegionFilter(e.target.value)}>
            <option value="">Toutes les regions</option>
            {REGIONS.map(r => <option key={r} value={r}>{r}</option>)}
          </select>

          <label className="carto-toggle">
            <input type="checkbox" checked={showManaged} onChange={e => setShowManaged(e.target.checked)} />
            <span className="toggle-dot managed"></span>
            Stations suivies ({managedFiltered.length})
          </label>

          <label className="carto-toggle">
            <input type="checkbox" checked={showAll} onChange={e => setShowAll(e.target.checked)} />
            <span className="toggle-dot all"></span>
            Reseau TotalEnergies ({stationsFiltered.length})
          </label>
        </div>
      </div>

      <div style={{ display: 'flex', gap: 16 }}>
        <div ref={mapRef} style={{
          flex: 1, height: 'calc(100vh - 220px)', borderRadius: 10,
          boxShadow: '0 2px 12px rgba(0,0,0,0.1)', overflow: 'hidden',
          border: '2px solid #e0e0e0'
        }}></div>

        <div style={{ width: 280, maxHeight: 'calc(100vh - 220px)', overflowY: 'auto' }}>
          <div className="card" style={{ marginBottom: 12 }}>
            <h3 style={{ fontSize: 14 }}>Legende</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8, fontSize: 13 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <div style={{ width: 22, height: 22, borderRadius: '50%', background: '#ED0000', border: '3px solid #fff', boxShadow: '0 1px 4px rgba(0,0,0,0.3)', flexShrink: 0 }}></div>
                <span>Station suivie (geree)</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <div style={{ width: 12, height: 12, borderRadius: '50%', background: '#FF6B35', border: '2px solid #fff', boxShadow: '0 1px 4px rgba(0,0,0,0.3)', flexShrink: 0, marginLeft: 5 }}></div>
                <span>Reseau TotalEnergies</span>
              </div>
            </div>
          </div>

          <div className="card">
            <h3 style={{ fontSize: 14 }}>Stations suivies</h3>
            {managedFiltered.map((s: any) => (
              <div key={s.id} className="station-list-item" onClick={() => {
                if (mapInstance.current && s.latitude && s.longitude) {
                  mapInstance.current.setView([Number(s.latitude), Number(s.longitude)], 15);
                }
              }}>
                <div style={{ fontWeight: 600, fontSize: 13, color: '#004A97' }}>{s.nom}</div>
                <div style={{ fontSize: 11, color: '#888' }}>{s.ville} - {s.region}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cartographie;
